import { Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

export type ToastSeverity = "info" | "success" | "warning" | "error"

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) {}

  show(severity: ToastSeverity, message: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
    switch(severity) {
      case 'info': return this.toastr.info(message, title, override)
      case 'success': return this.toastr.success(message, title, override)
      case 'warning': return this.toastr.warning(message, title, override)
      case 'error': return this.toastr.error(message, title, { disableTimeOut: true, ...override })
    }
  }

  /**
   * Dismisses a toast previously returned by `show`. Safe to call with `undefined`.
   *
   * @param {ActiveToast<any>} toast - The toast to dismiss.
   */
  hide(toast?: ActiveToast<any>): void {
    if (toast) {
      this.toastr.clear(toast.toastId)
    }
  }

  initLegacyFlashMessageHandling() {
    window.addEventListener('message', (event: MessageEvent) => {
      if (event.origin ===  environment.legacyAppUrl) {
        if(event.data.kind === 'flash_message') {
          this.show(this.mapLegacyFlashMessageSeverity(event.data.severity), event.data.text)
        }
      }
    });
  }

  private mapLegacyFlashMessageSeverity(severity: string): ToastSeverity {
    switch(severity) {
      case "success": return "success"
      case "error": return "error"
      default: return "info"
    }
  }
}
